export default __webpack_public_path__ + "static/media/contact-img.ed47ef55.jpeg";